module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Regional Reps")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Responsible Reps")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-0 pb-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.availableReps != '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1), _vm._v(" "), (_vm.availableReps != '') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.availableReps,
      "rows-per-page-items": [20, 40, 60, 80, 100],
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          on: {
            "click": function($event) {
              return _vm.fncSaveUser(props.item.id, props.item.selected)
            }
          },
          model: {
            value: (props.item.selected),
            callback: function($$v) {
              _vm.$set(props.item, "selected", $$v)
            },
            expression: "props.item.selected"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_vm._v(_vm._s(props.item.fullname))])]
      }
    }], null, false, 2512190990)
  }) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v(" No regional users could be found")])])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.explodedRepUsers != '') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.explodedRepUsers,
      "rows-per-page-items": [20, 40, 60, 80, 100],
      "search": _vm.search,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          on: {
            "click": function($event) {
              return _vm.fncSaveResponseUser(props.item.id, _vm.globalModalParams.quoteId.id, props.item.selected)
            }
          },
          model: {
            value: (props.item.selected),
            callback: function($$v) {
              _vm.$set(props.item, "selected", $$v)
            },
            expression: "props.item.selected"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "90%"
          }
        }, [_vm._v(_vm._s(props.item.fullname))])]
      }
    }], null, false, 3457983623)
  }) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v(" No rep users could be found")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}